const stopPropagation = (e: React.MouseEvent | React.KeyboardEvent | React.DragEvent | React.FocusEvent) =>
  e.stopPropagation();
const preventDefault = (e: React.MouseEvent | React.KeyboardEvent | React.DragEvent) => e.preventDefault();

export { stopPropagation, preventDefault };
